export const logInStatus = (data) => {
  return {
    type: "LOGINSTAT",
    data: data,
  };
};
